import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const SearchAutoItem = styled.li`
  .btn {
    height: 44px;
    width: 100%;
    justify-content: flex-start;
    position: relative;
    text-align: left;
  }

  .text {
    line-height: 130%;
  }

  em {
    color: #ff4600;
  }

  .tag {
    flex-shrink: 0;
    line-height: 120%;
    font-size: 9px;
    margin-left: 6px;

    + .tag {
      margin-left: 2px;
    }

    &.tag-exclusive {
      color: #fff;
      background-color: #000;
    }
  }

  svg {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      height: ${mixin.pxToVw('44')};
    }

    .tag {
      font-size: ${mixin.pxToVw('9')};
      margin-left: ${mixin.pxToVw('6')};

      + .tag {
        margin-left: ${mixin.pxToVw('2')};
      }
    }
  }
`;
